import React from "react";
import { IForm } from "../models/Form.model";
import { InputSwitch } from "primereact/inputswitch";

interface SharedInputSwitchProps {
  item: IForm;
  handleFormData: any;
}

export default function SharedInputSwitch({
  item,
  handleFormData,
}: SharedInputSwitchProps) {
  return (
    <div className="form-group switch">
      <label>{item.label}</label>
      <InputSwitch
        checked={item.value}
        onChange={(e) => handleFormData(e.value)}
      />
    </div>
  );
}
